import {useRef, useState} from 'react';
import {SimpleGrid} from '@mantine/core';
import {useProviderMappings} from '../hooks/useProviderMappings';
import {useProviderMappingsSelection} from '../hooks/useProviderMappingsSelection';
import {useTableColumns} from '../hooks/useTableColumns';
import {MantineDataTable, TableSearchForm,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import {FormDrawer} from '../drawers/FormDrawer.tsx';

export const RecordsTable = ({productId, customerId, priceId}: { productId?: string, customerId?: string, priceId?: string }) => {
    const {selectedRecords, setSelectedRecords} = useProviderMappingsSelection();
    const [drawerOpened, setDrawerOpened] = useState(false);

    const {
        items,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useProviderMappings(productId, customerId, priceId);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    // Items are already filtered by the hook, no need for client-side filtering
    const filteredItems = items;

    const handleRecordClick = () => {
        setDrawerOpened(true);
    };

    const {columns} = useTableColumns({onRecordClick: handleRecordClick});

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={filteredItems}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                noRecordsText={productId ? "No billing provider mappings found for this product" : customerId ? "No billing provider mappings found for this customer" : priceId ? "No billing provider mappings found for this price" : "No provider mappings found"}
            />

            {!productId && !customerId && !priceId && (
                <DataTableTokenPagination
                    loadedCount={filteredItems.length}
                    nextToken={nextToken}
                    handleLoadMore={fetchRecords}
                />
            )}

            <FormDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </SimpleGrid>
    );
};
